import { Form } from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import { get, isArray } from 'lodash-es';
import { FieldData } from 'rc-field-form/es/interface';
import { useEffect } from 'react';

import { ErrorFormInterface, ErrorStackInterface } from '@interface/form/error-form.interface';
import { isExist } from '@util/data/is-exist';

interface FormErrorProps {
  errorField: string | string[];
  customErrorField?: string | string[];
  error?: ErrorFormInterface | null;
}

const formatError = (errors: ErrorStackInterface[], parent: string[] = [], errorFields: FieldData[] = []) => {
  errors.forEach((currentError) => {
    if (isArray(currentError.children) && currentError.children.length > 0) {
      formatError(currentError.children, [...parent, currentError.property], errorFields);
    } else {
      errorFields.push({
        name: [...parent, currentError.property],
        value: currentError.value,
        errors: currentError.constraints,
      });
    }
  });

  return errorFields;
};

export const FormError = ({ error, errorField, customErrorField }: FormErrorProps) => {
  const form = useFormInstance();
  const formValues = Form.useWatch([], form);

  const clearError = (input: object, path: string[] = []) =>
    isExist(input) &&
    Object.keys(input).forEach((key) => {
      form.setFields([
        {
          name: [...path, key],
          errors: [],
        },
      ]);

      if (typeof get(input, key) === 'object') clearError(get(input, key), [...path, key]);
    });

  useEffect(() => void clearError(formValues), [formValues]);

  useEffect(() => {
    const stackErrors = get(error, ['data', 'error', 'stack']);

    if (isArray(stackErrors) && stackErrors.length > 0) {
      return void form.setFields(
        formatError(
          stackErrors.map((error) =>
            error.property !== customErrorField
              ? error
              : {
                  ...error,
                  property: errorField[0] as string,
                },
          ),
        ),
      );
    }

    const errorValidation = get(error, ['data', 'error', 'message']) ?? get(error, ['error']) ?? error;

    if (isExist(errorValidation))
      form.setFields([
        {
          name: errorField,
          errors: [errorValidation],
        },
      ]);
  }, [form, error]);

  useEffect(() => () => form.resetFields(), []);

  return <></>;
};
